export const TIME_FORMAT_KEY = 'timeFormat'

export const TIME_ZONE_KEY = 'timezone'
